import { defineComponent as _defineComponent } from 'vue';
import PanelHeader from '@/components/renewal/common/panel-header.vue';
import BinderSection from '@/components/renewal/collection/binder-section.vue';
import QuickAccessSection from '@/components/renewal/collection/quick-access-section.vue';
import Icon from '@/components/renewal/common/icon.vue';
import { useAuth } from '@/plugins/auth';
export default /*#__PURE__*/_defineComponent({
  __name: 'collection-panel',
  setup: function setup(__props) {
    var auth = useAuth();

    // バインダー権限がない場合はバインダーセクションを表示しない
    var showBinderSection = computed(function () {
      return auth.permissions.binder;
    });
    return {
      __sfc: true,
      auth: auth,
      showBinderSection: showBinderSection,
      PanelHeader: PanelHeader,
      BinderSection: BinderSection,
      QuickAccessSection: QuickAccessSection,
      Icon: Icon
    };
  }
});